import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopAdhesionFs from './freestar/Adhesion';
import DesktopAdhesionTab from './taboola/DesktopAdhesion';
const DesktopAdhesion = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(DesktopAdhesionTab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopAdhesionFs, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
